// appRoutes.tsx
import { Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from '@/components/layouts/MainLayout';
import ProtectedRoute from '@/components/common/ProtectedRoute';

import Login from '@/features/auth/pages/Login';
import BookingList from '@/features/booking/pages/BookingList';
import BookingDetail from '@/features/booking/pages/BookingDetail';
import Driver from '@/features/driver/pages/Driver';
import Vehicle from '@/features/vehicle/pages/Vehicle';
import OnDemandHistoryPage from '@/features/on-demand/pages/OnDemand/OnDemandHistory';
import OnDemandAssignment from '@/features/on-demand/pages/OnDemand/OnDemandAssignment';

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Navigate to="/booking-list" replace />} />
      <Route
        path="/booking-list"
        element={
          <ProtectedRoute>
            <MainLayout>
              <BookingList />
            </MainLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/booking-list/:id"
        element={
          <ProtectedRoute>
            <MainLayout>
              <BookingDetail />
            </MainLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/vehicle"
        element={
          <ProtectedRoute>
            <MainLayout>
              <Vehicle />
            </MainLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/driver"
        element={
          <ProtectedRoute>
            <MainLayout>
              <Driver />
            </MainLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/on-demand/list"
        element={
          <ProtectedRoute>
            <MainLayout>
              <OnDemandAssignment />
            </MainLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/on-demand/history"
        element={
          <ProtectedRoute>
            <MainLayout>
              <OnDemandHistoryPage />
            </MainLayout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default AppRoutes;
